import React, { Component, Fragment } from 'react';
import PropTypes from 'proptypes';
import Modal from 'react-modal';
import moment from 'moment';
import TripAddOns from '../../screens/UserProfile/TripAddOns';
import MakePayment from '../../lib/forms/MakePayment';
import DocumentsAccordion from '../../lib/documentsAccordion/DocumentsAccordion';
import TripTopBar from '../../lib/tripTopBar/TripTopBar';
import ImportantInfo from '../../lib/importantInfo/ImportantInfo';
import FundRaiseSideBar from '../../lib/fundraiseSideBar/FundRaiseSideBar';
import HelpfulLinks from '../../lib/helpfulLinks/HelpfulLinks';
import FriendsAndSupporters from '../../lib/friendsAndSupporters/FriendsAndSupporters';
import MakeDeposit from '../../lib/forms/MakeDeposit';
import MakeDepositModal from '../../lib/forms/MakeDepositModal';
import { formatPackageTitle, getActualStartDate } from './../../../helpers/TripHelper';

import './Opportunity.scss';

export default class Opportunity extends Component {
  state = {
    activeModal: null,
    activeHash: null,
  };

  locationHashChanged = () => {
    if (window.location.hash && window.location.hash !== this.state.activeHash) {
      const scrollElement = document.getElementById(window.location.hash.substring(1));
      if (scrollElement && scrollElement.offsetTop) {
        window.scrollTo({
          top: scrollElement.offsetTop - 100,
          behavior: 'smooth',
        });
      }
      this.setState({
        activeHash: window.location.hash,
      });
    }
  };

  componentDidMount() {
    this.locationHashChanged();
  }

  componentDidUpdate() {
    this.locationHashChanged();
  }

  setParentTripValue = (tripIndex, name, value) => {
    this.props.user.trips[[tripIndex]][name] = value;
  };

  openModal = modalName => {
    this.setState({
      activeModal: modalName,
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  setOpportunityScrollTo = id => {
    document.querySelector(`#${id}`).scrollIntoView({
      behavior: 'smooth',
    });
  };

  hasUploadedAllDocuments = tripId => {
    this.setState({ allDocumentsUploaded: tripId });
  };

  render() {
    const { user, activeTab, toggleActiveTrip } = this.props;
    const userTrips = {};

    user.trips.forEach((trip, index) => {
      userTrips[trip.id] = (
        <Fragment key={trip.id}>
          {trip.payments.tripAmount - trip.payments.tripBalance < trip.payments.deposit ? (
            <Fragment>
              <MakeDeposit
                trip={trip}
                tripIndex={index}
                tripId={trip.id}
                history={this.props.history}
                openModal={() => this.openModal('makeDepositModal')}
                currentAddOns={trip.currentAddOns}
                handleRouting={this.props.handleRouting}
                setParentState={this.props.setParentState}
                setParentTripValue={this.setParentTripValue}
                setTripState={this.props.setTripState}
                addTripAddOn={this.props.addTripAddOn}
                deleteTripAddOn={this.props.deleteTripAddOn}
                deleteTripHandler={this.props.deleteTripHandler}
                setAppState={this.props.setAppState}
                userProps={this.props.userProps}
                additionalTripCost={this.props.additionalTripCost}
                user={user}
                isProcessing={this.props.isProcessing}
              />
              <Modal
                isOpen={this.state.activeModal === 'makeDepositModal'}
                onRequestClose={this.closeModal}
                overlayClassName="overlay"
              >
                <MakeDepositModal closeModal={this.closeModal} />
              </Modal>
            </Fragment>
          ) : (
            <div className="row">
              <div className="col-md-12 margin-bottom-container">
                <div className="col-md-12 styled-container no-padding-col">
                  <TripTopBar
                    trip={trip}
                    currentAddOns={trip.currentAddOns}
                    setTripState={this.props.setTripState}
                    deleteTripAddOn={this.props.deleteTripAddOn}
                    addTripAddOn={this.props.addTripAddOn}
                    tripIndex={index}
                    user={user}
                    tripId={trip.id}
                    allDocumentsUploaded={this.state.allDocumentsUploaded}
                    isProcessing={this.props.isProcessing}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="row importantInfoContainer chevrons-right-texture">
                  <div className="col-md-12 styled-container">
                    <ImportantInfo
                      startDate={trip.startDate}
                      tripFBGroup={trip.tripFBGroup}
                      tripId={trip.id}
                      tripAddons={trip.currentAddOns}
                      tripDestination={trip.destination}
                      mailingCountry={user.mailingCountry}
                      allDocumentsUploaded={this.state.allDocumentsUploaded}
                      flightStatus={trip.tripFlightStatus}
                    />
                  </div>
                </div>
                <div className="row importantInfoContainer chevrons-right-texture">
                  <div className="col-md-12 styled-container">
                    <FundRaiseSideBar userId={user.id} tripId={trip.id} />
                  </div>
                </div>
                <div className="row helpfulLinksContainer chevrons-right-texture">
                  <div className="col-md-12 styled-container margin-bottom-container">
                    <HelpfulLinks />
                  </div>
                </div>
              </div>
              <div className="col-md-9 responsive-col">
                <div className="row">
                  <div className="col-md-6 col-sm-12 padding-right">
                    <MakePayment
                      trip={trip}
                      tripId={trip.id}
                      tripIndex={index}
                      tripName={trip.destination}
                      payments={trip.payments}
                      currentAddOns={trip.currentAddOns}
                      availableAddOns={trip.availableAddOns}
                      additionalTripCost={this.props.additionalTripCost}
                      handleRouting={this.props.handleRouting}
                      setOpportunityState={this.props.setOpportunityState}
                      user={user}
                      setTripState={this.props.setTripState}
                      togglePaymentDetails={this.togglePaymentDetails}
                      paymentDetails={this.state.paymentDetails}
                    />
                    <div className="extra-padding-container">
                      <TripAddOns
                        viewMode="comprehensive"
                        setOpportunityScrollTo={this.setOpportunityScrollTo}
                        updateTripCost={this.props.updateTripCost}
                        hasPaidDeposit
                        addTripAddOn={this.props.addTripAddOn}
                        availableAddOns={trip.availableAddOns}
                        setParentTripValue={this.setParentTripValue}
                        setTripState={this.props.setTripState}
                        user={user}
                        tripId={trip.id}
                        tripIndex={index}
                      />
                    </div>
                    <div className="extra-padding-container">
                      <FriendsAndSupporters tripId={trip.id} />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 documents-accordion padding-right">
                    <DocumentsAccordion
                      setAppState={this.props.setAppState}
                      hasUploadedAllDocuments={this.hasUploadedAllDocuments}
                      user={user}
                      userProps={this.props.userProps}
                      trip={trip}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Fragment>
      );
    });

    return (
      <Fragment>
        {user.trips.length > 1 ? (
          <div className="trip-nav-bar row">
            {user.trips.map(trip => (
              <div
                key={trip.id}
                className={
                  user.trips.length <= 4
                    ? `col-md-${Math.floor(12 / user.trips.length)}`
                    : 'col-md-3'
                }
              >
                <button
                  className={`trip-tab ${activeTab === trip.id ? 'active-trip-tab' : ''}`}
                  onClick={() => toggleActiveTrip(`${trip.id}`)}
                >
                  {' '}
                  {formatPackageTitle(trip.destination, trip.currentAddOns)}{' '}
                  {activeTab !== trip.id
                    ? moment(getActualStartDate(trip.startDate, trip.currentAddOns)).format(
                        'MMM. Do'
                      )
                    : ''}
                </button>
              </div>
            ))}
          </div>
        ) : (
          ''
        )}
        {userTrips[activeTab]}
      </Fragment>
    );
  }
}

Opportunity.propTypes = {
  setAppState: PropTypes.func,
  setTripState: PropTypes.func,
  updateTripCost: PropTypes.func.isRequired,
  additionalTripCost: PropTypes.number,
  deleteTripHandler: PropTypes.func.isRequired,
  setParentState: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  toggleActiveTrip: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired,
  deleteTripAddOn: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  userProps: PropTypes.shape({
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
  }),
};
Opportunity.defaultProps = {
  setTripState: () => {},
  setAppState: () => {},
  userProps: {},
};
